import Vue from 'vue'
import Vuex from 'vuex'
import accountModule from './accountModule';
import bookingModule from './bookingModule';
import VuexPersist from 'vuex-persist';
//import VueCookies from 'vue-cookies';

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: "ba",
  storage: window.localStorage,
  reducer: (state) => {
    console.log("save state:", state);
    if (!state.domain) state.domain = window.location.origin;
    return state;
  },
  restoreState: (key, storage) => {
    console.log("restore state", window.location.origin);

    if (!storage["ba"]) return null;
    const storeStateJson = storage["ba"];
    if (!storeStateJson) return null;
    let storeState = JSON.parse(storeStateJson);
    //console.log('state: ', storeState);
    
    if (!storeState) return null;
    if(storeState.domain != window.location.origin) return null;

    let config = storeState.booking.configuration;
    if (!config) return null;

    config.apiKey = window.websiteSettings.apiKey;
    config.stripeId = window.websiteSettings.stripeId;
    config.paypalId = window.websiteSettings.paypalId;
    config.contactPhone = window.websiteSettings.contactPhone;
    config.country = window.websiteSettings.country;
    config.companyName = window.websiteSettings.companyName;
    config.companyTermsAndCondHtml = window.websiteSettings.companyTermsAndCondHtml;
    config.showCallOnTooClosePickup = window.websiteSettings.showCallOnTooClosePickup;
    config.showCallOnNotCoveredPickup = window.websiteSettings.showCallOnNotCoveredPickup;
    config.showSpecialOffersButton = window.websiteSettings.showSpecialOffersButton;
    config.defaultBookingType = window.websiteSettings.defaultBookingType;
    config.showBookingTypeSwitcher = window.websiteSettings.showBookingTypeSwitcher;
    config.showReturnOption = window.websiteSettings.showReturnOption;
    config.canConfirmByCash = window.websiteSettings.canConfirmByCash;
    config.hidePassengers = window.websiteSettings.hidePassengers;
    config.hideMeetAndGreet = window.websiteSettings.hideMeetAndGreet;
    config.hideFlightInfo = window.websiteSettings.hideFlightInfo;

    if (!window.websiteSettings.isDrivano) {
      config.isDrivano = false;
      config.showSpecialOffersButton = false;
      config.showBookingTypeSwitcher = true;
      config.showReturnOption = true;
      config.hidePassengers = false;
      config.hideMeetAndGreet = false;
      config.hideFlightInfo = false;
    }

    return storeState;
  },
});

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    domain: null,
    websiteGuid: null,
    userEmail: null,
    account: null
  },
  getters: {
    // isAuthenticated1: state => {
    //   return state.isLoggedIn;
    // }
  },
  mutations: {
    setWebsiteGui(state, websiteGuid){
      state.websiteGuid = websiteGuid;
    } 
  },
  actions: {    
  },
  modules: {
    account: accountModule,
    booking: bookingModule
  }
})